<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="280px">
      <template v-slot:activator="{ on, attrs }">
        <CustomThemedButton dark color="primary" v-bind="attrs" v-on="on">
          Export
        </CustomThemedButton>
      </template>
      <v-card>
        <v-card-title class="mt-2"
          ><v-row>
            <v-icon class="mr-1" color="blue">mdi-file-export-outline</v-icon>
            Export Voyage Routes
          </v-row>
        </v-card-title>

        <v-card-text style="height: 280px">
          <v-col class="mt-4 pa-0">
            <p>File Format</p>
            <v-radio-group v-model="selectedFormat" row dense class="mt-2 pa-0">
              <v-radio label="RTZ" :ripple="false" value="rtz"></v-radio>
              <v-radio label="CSV" :ripple="false" value="csv"></v-radio>
            </v-radio-group>
            <div class="mt-4">
              <p>Optimization Type</p>
            </div>
            <v-radio-group v-model="selectedFormat" column class="mt-2 pa-0">
              <v-checkbox
                label="Min Fuel"
                value="min_fuel"
                class="ma-0 pa-0"
                :ripple="false"
                dense
                v-model="selectedTypes"
              ></v-checkbox>
              <v-checkbox
                label="Min Time"
                value="min_time"
                :ripple="false"
                class="mt-1 pa-0"
                dense
                v-model="selectedTypes"
              ></v-checkbox>
              <v-checkbox
                label="Best TCE"
                value="best_tce"
                class="mt-1 pa-0"
                :ripple="false"
                dense
                v-model="selectedTypes"
              ></v-checkbox>
              <v-checkbox
                v-if="voyageHasDtaSolution"
                label="Best DTA"
                value="best_dta"
                class="mt-1 pa-0"
                :ripple="false"
                dense
                v-model="selectedTypes"
              ></v-checkbox>
            </v-radio-group>
          </v-col>
        </v-card-text>
        <v-btn
          color="primary"
          class="mr-2"
          outlined
          rounded
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn color="primary" rounded @click="onExportPressed"> Export </v-btn>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import CustomThemedButton from "@/core/CustomThemedButton.vue";
export default {
  name: "ExportVoyageData",
  components: { CustomThemedButton },
  data() {
    return {
      selectedTypes: [],
      selectedFormat: "rtz",
      dialog: false,
    };
  },
  computed: {
    ...mapGetters("weatherRouting/formModule", ["getThereIsVoyageData"]),
    ...mapGetters("weatherRouting/voyageDetailsModule", [
      "voyageHasDtaSolution",
    ]),
  },
  methods: {
    onExportPressed: async function () {
      const fileData = await this.$store.dispatch(
        "weatherRouting/voyageDetailsModule/exportVoyageData",
        {
          fileFormat: this.selectedFormat,
          optimizationTypes: this.selectedTypes,
        }
      );
      this.forceFileDownload(fileData, "routeData");
    },
    forceFileDownload(data, title) {
      const url = window.URL.createObjectURL(
        new Blob([data], {
          type: "application/zip",
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>